import { BankOperation, BankTxType } from "@1games-ru/region-shared/dist/types/bank/bank";
import { useQuery } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";

export type BankTransaction = {
  id: string;
  type: BankTxType;
  amount: number;
  operation: BankOperation;
  createdAt: string;
};

export const QUERY_KEY_BANK_TRANSACTIONS = "bank-transactions";

export function useBankTransactionsQuery({ page, limit }: { page: number; limit: number }) {
  return useQuery({
    queryKey: [QUERY_KEY_BANK_TRANSACTIONS, page, limit],
    queryFn: async () => {
      const response = await BankMpProvider.getTransactions({
        page,
        limit,
        sort: "desc",
      });

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.error?.message);
      }

      return response.data;
    },
    select: (data) => {
      console.log({ data });
      const items = data.items.map(
        (transaction) =>
          ({
            id: transaction.id,
            type: transaction.type,
            amount: transaction.amount,
            operation: transaction.operation,
            createdAt: new Date(transaction.createdAt).toISOString(),
          }) satisfies BankTransaction,
      );

      return { ...data, items };
    },
  });
}
